import Email from "@/domain/entities/emails/Email";

/**
 * The people a mail of an answer is shown by: its sender, or, for a mail the user sent, the people
 * it was sent to (to, then cc).
 */
export const mailPeople = (mail: Email, sent: boolean): string[] =>
    (sent ? [...(mail.to ?? []), ...(mail.cc ?? [])] : [mail.from])
        .map((person) => person?.name || person?.email || "")
        .filter(Boolean);

/** One name, and how many more: « Marie-Anne Lefort +2 ». */
export const peopleLabel = (names: string[]): string =>
    names.length > 1 ? `${names[0]} +${names.length - 1}` : (names[0] ?? "");
